module.exports = __webpack_public_path__ + "media/images/icons/certificate-green-5f86904430b9e217ba5c2d02c67c1772.png";